import { useEffect, useState } from "react";

import { CheckIcon, CopyIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";

interface CopyButtonProps {
  /** Nusxalanadigan qiymat — ekranda KO'RSATILMAYDI. */
  value: string;
  /** Tugmadagi matn (masalan "Havolani nusxalash"). */
  label: string;
}

/**
 * Tashqi manzillar (MinIO obyektlari, uchrashuv havolalari) foydalanuvchiga
 * hech qachon ko'rinadigan havola sifatida CHIQARILMAYDI: mahsulot talabi
 * bo'yicha panelda yangi tab ochiladigan hech narsa yo'q. Kerak bo'lganda
 * qiymat buferga nusxalanadi va odam uni o'zi qayerga qo'yishni hal qiladi.
 */
export const CopyButton = ({ value, label }: CopyButtonProps) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const id = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(id);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      // Clipboard API ruxsat bermasligi mumkin (HTTP, eski brauzer).
      toast.error(t("COMMON.COPY_FAILED"));
    }
  };

  return (
    <Button type="button" variant="outline" size="sm" onClick={() => void copy()}>
      {copied ? <CheckIcon className="size-4" /> : <CopyIcon className="size-4" />}
      {copied ? t("COMMON.COPIED") : label}
    </Button>
  );
};
